/*
 * @Author: 宋慧武
 * @Date: 2019-04-14 17:01:49
 * @Last Modified by: 宋慧武
 * @Last Modified time: 2019-04-14 17:12:29
 */
import trackEvents from "./events";

export { default as trackAction } from "./action";

export default {
  ...trackEvents
};
